<!-- ::用法示例::
  <myform 
    xref='actived' 

    hidebutton
    
    view.selectMyAttention="查看关注列表#el-icon-view#删除"

    @close='$form("selectMyAttention","hide")'
    confirm='submit=>submit().then(...)' 
    :viewobj="{
      addUser  : [ '新增用户信息', 'el-icon-circle-plus' ], 
      editUser : [ '修改用户信息', 'el-icon-edit-outline'],
      $button$ : [ '取消', '确定' ],
      $succeed$: selectContact
    }"

    @close='$form("editUser","reset")'
    confirm='submit=>submit().then(...)'
    >
    
    <mytable
      ref='table_selectMyAttention'
      :tableColums='tableColums_selectMyAttention||[]'
    
      api='selectMyAttention'
      x:data='selectMyAttention_data.data||[]'
      
      v-event.selectMyAttention='`selectMyAttention({})`'
      
      :height="H-285"
    
      @current-change="(row,oldrow,table)=>{}"
    
      @row-click="(row,oldrow,table)=>{}" 
      /> 

  </myform> 
-->

<template>
  <div class="MyForm" @click.capture="clickElement = $event.target">
    <el-dialog ref='$dialog' v-drag :visible='!!actived' :fullscreen="!!fullscreen || fullscreen === ''"
      @update:visible="cancel" @opened='opened' @closed='closed' :title='title' remark="👆上面是自定义的,👇下面是固定的无需修改"
      :top='top || "10vh"' :width='width || "60%"' x:destroy-on-close='true' :disabled='readonly === void 0 || readonly'
      :close-on-click-modal="false">
      <el-form v-if='Myformdata' ref='$form' :model="Myformdata" :rules="Myruleobj" label-width="300px"
        :validate-on-rule-change='false' :size='size || "medium"' @submit.prevent.native>

        <div v-for="(form, prop) in Myruleobj" :key='prop'>
          <el-form-item v-if='$slots[prop] ? $slots[prop][0].tag !== "hide" : true' :label="form.label.split('|')[0]"
            :prop='prop'>

            <slot v-if='$scopedSlots[prop]' :name='prop' :prop='{ form, prop }'
              :Myformdata='Myformdata.hideProperty("$myform", _self)'></slot>

            <el-input v-else v-model="Myformdata[prop]" clearable
              vs:600.outline=' actived ? "none" : "1px solid var(--Colorlight)" '
              v-s:300.width='actived ? "100%" : "70%"' :placeholder='form.placeholder ||
    (form.length > 0 ? "请输入" : "可在此输入") + form.label + (form.length > 0 ? "" : "..")
    ' @keydown.enter.native='confirm()' />
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if='ihidebutton !== true && icon !== "#"'>
        <el-button v-if='(viewobj && viewobj.$button$ || Myviewobj.$button$ || [])[0]' @click="cancel(null)"
          v-s:300.opacity='actived ? 1 : 0' remark="👆上面是自定义的,👇下面是固定的无需修改" :size='size || "medium"'>{{ (viewobj &&
    viewobj.$button$ || Myviewobj.$button$)[0] }}</el-button>

        <el-button v-if='(viewobj && viewobj.$button$ || Myviewobj.$button$ || [])[1]' @click="confirm"
          vs:150.opacity=' actived ? 1 : 0 ' v-s:300.transform='actived ? "scale(1.0)" : "scale(1.3)"' click="
            Myformdata[actived]().selectContact
            .then(e=>$trigger('closeDialog').selectContact)

            $trigger([actived, 'closeDialog', 'selectContact'])
            Myformdata[actived]().$trigger('closeDialog')
            .then(e=>$trigger('closeDialog').selectContact)
            .$nextTick('selectContact',{name:inputText})
          " remark="👆上面是自定义的,👇下面是固定的无需修改" :icon=icon :size='size || "medium"' :type="btntype || 'primary'">{{ (viewobj
    && viewobj.$button$ || Myviewobj.$button$ || [] )[1] }}</el-button>
      </div>

      <slot tip='默认匿名插槽'></slot>

    </el-dialog>

    <!-- <div
      v-for='(item,prop) in object' :key='prop'
      >
      <slot vif='$scopedSlots[prop]' :name='prop' :prop='prop' tip='传递参数的插槽'></slot>
      <span >{{ ( typeof $scopedSlots[prop] + prop ) }}</span> 
    </div> -->
    <!-- <slot name='email1' :prop='111' tip='传递参数的插槽'></slot>
    <slot name='email2' :prop='222' tip='传递参数的插槽 '></slot> -->
    <!-- <slot tip='默认匿名插槽'></slot>
    <slot :name='"name"' tip='email插槽'></slot>
    <slot :name='"email"' tip='email插槽'></slot> -->
  </div>
</template>

<script>

const $id$ = '__isMyForm__', W = window,

  $forEach = forEach, $return = Return,

  hideProperty = A.hideProperty;

/*const ICONS = {
  'el-icon-delete': 'danger',
  __proto__: null,
};*/

export default {
  name: 'MyForm',
  props: ['formdata', 'ruleobj', 'viewobj', 'hidebutton', 'width', 'top', 'readonly', 'size', 'btntype', 'fullscreen'],
  data() {
    let viewobj = this.viewobj, $button$ = ['', ''];
    if (viewobj)
      $button$ = viewobj.$button$ = viewobj.$button$ || ['取 消', '确 定']
    // console.error("data::",viewobj,this);
    return {
      icon: '',
      title: '',
      actived: '',
      // size: 'medium',
      canceltext: $button$[0] || '',
      confirmtext: $button$[1] || '',
      ihidebutton: false,
      Myformdata: null,
      Myruleobj: null,
      Mylastactived: '',
      Myviewobj: viewobj || {},
    }
  },
  watch: {
    Myformdata() {
      console.log(this.Myformdata)
    },
    actived(actived) {
      // console.warn("actived::",actived);
      if (!actived) return;
      this.$emit('show', this); // , sleep.clear(50.10159,v=>this.$emit('showed',this));
      // console.error(actived, this.Mylastactived);
      // this.Form && this.Form.clearValidate();
      // console.warn(this.Myformdata);
      (this.Mylastactived !== (this.Mylastactived = actived) || !this.Myformdata) && (
        (() => this.Form && this.Form.clearValidate()).sleep(10),
        this.getformdata()
      );
      // return;
      const viewobj = this.viewobj || this.Myviewobj;
      // console.error(actived, this.title);
      if (typeof actived === "object") {
        this.title = (this.icon = actived[1] || "", actived[0]);
        return;
      };
      // console.warn(this, actived, viewobj);
      actived = viewobj[actived];
      this.title =
        typeof actived === "object"
          ? (this.icon = actived[1] || "", actived = actived[0])
          : actived;
      actived.includes('新增') && this.Form && sleep(0).then(v => this.Form.clearValidate());
    },
  },
  methods: {
    confirm: async function (res, succeed) {
      // console.error(5555555555);
      const $host = this.$host;
      let Myformdata = $host.Myformdata = this.Myformdata;
      if (!await (this.Form ? this.Form.validate() : true)) return null;
      // console.error(this.$listeners);
      if (this.$listeners.confirm && res !== "$$MYCONFIRM$$") {
        // @confirm='(submit,Myformdata,url)=>$post(url,Myformdata).then(submit.waitRun(true))'
        return this.$emit('confirm', this.confirm.bind(this, "$$MYCONFIRM$$"), Myformdata, this.actived, this), null;
      };
      if (succeed !== true) {
        const template = $host[this.actived];
        // console.warn(template, $host, this.actived );
        if (template.$Apiname$) {
          // this.$post(this.actived,Myformdata);
          // console.error(Myformdata.dealReason,toKeys(Myformdata));
          res = await this.$trigger(this.actived, Myformdata).async();
          // res = await this.$post(this.actived,Myformdata);
          // console.error(res,666666666666666,55555555555,template.$Apiname$);
          if (!res) return false;
        } else {
          if (!(res = await template.call($host, Myformdata))) return false;
        };
      };

      const title = this.title;
      alertSuccess(Void(res.data, 'msg') || '该' + title.slice(2) + title.slice(0, 2) + '成功！', 1000);
      const $succeed$ = (this.viewobj || this.Myviewobj).$succeed$;
      if ($succeed$) {
        let actived = this.actived, name;
        succeed !== 'submit' && (this.actived = '');
        await this.$nextTick();
        (typeof (name = $succeed$) === 'string' || (name = $succeed$.$Apiname$) || (name = $succeed$.showName) && ($host.$$events || 0)[name])
          ? $host.$trigger(name)
          : $succeed$.call($host);
        // console.warn( actived, 5555555555 );
        succeed !== 'submit' && $host.$form(actived, 'resetForce');
      } else succeed !== 'submit' && (this.$emit('close', this), this.actived = '');

      return succeed !== 'submit' ? true : res;
      /*if( typeof template.$next === 'function' ) {
        template.lastRes = true, template.$next2 = false;
        Myformdata = $return( this.Myruleobj, (params, value, name)=>params[name] = ( value = Myformdata[name] ) == null ? '' : value, { __proto__: null }  );
        template.args = [ '正在提交表单..', Myformdata ];
        if( ! ( res = await template.$next() ) ) return false;
      } else */
    },
    cancel: async function (bool) {
      // console.error(9999999999);
      if (bool) return;
      // console.error(this.clickElement);
      const force = bool === null;
      this.$listeners.close
        ? (
          bool = this.clickElement,
          this.$emit('close', this, bool && bool.classList.contains('el-dialog__close') || force),
          bool && sleep(50, v => this.clickElement = false)
        )
        : this.actived = '';
      // bool = this.$listeners.close;
      // // console.warn(1111,bool);
      // if( bool && typeof ( bool = bool.fns ) === 'function' ) {
      //   bool = bool(this).then(v=>alert(55555));
      //   if( bool === false ) return false;
      // };
      // this.actived = '';
      // console.warn(22222, bool);
      // this.$host && this.$host.$trigger('close');
    },
    opened() {
      this.onOpened && this.onOpened();
      this.$opened && this.$opened(this.$opened = false);
      this.$emit('opened', this);
      if (this.Dialog.$el && (this.Dialog.fullscreen = this.Dialog.$el.fullscreen = !!this.fullscreen || this.fullscreen === "")) {
        // console.error(this.Dialog.fullscreen);
        this.Dialog.$el.firstElementChild.style.with({
          left: '0px',
          top: '0px'
        });
        // return false;
      };
    },
    closed() {
      // console.error(this.$closed);
      this.onClosed && this.onClosed();
      this.$closed && this.$closed(this.$closed = false);
      this.$emit('closed', this);
    },

    getformdata(init) {
      const ruleobj = this.ruleobj;
      // console.error(11111, this.actived, this.Mylastactived );
      // console.error( init, this.ruleobj );
      if (!this.ruleobj && init) return false;

      const $host = this.$host;
      // console.error( this.actived, $host.Apis, this.ruleobj, init  );
      const Myruleobj = this.Myruleobj = this.ruleobj === void 0
        ? ($host.Apiparams ? $host.Apiparams['$rule_' + this.actived] : $host.Apis[this.actived] && (myClone($host.Apis[this.actived].$rule)) || {})
        : this.ruleobj;
      // console.warn(Myruleobj);
      if (!Myruleobj) return {};
      // return console.warn(Myruleobj,$host.Cache,$host);

      // console.error(22222222222222);
      hideProperty(
        Myruleobj,
        '$Formdata',
        this.Myformdata = $host.Myformdata = Vue.observable(Return(Myruleobj, (a, _, k) => a[k] = "", {})) //$host.$set($host.Cache,'$Formdata',{})
      );
      // console.error( this.Myformdata, Myruleobj );
      return this.Myformdata;

    }
  },

  created() {
    // console.error(22222,this.viewobj,this);
    // if( !W.Appload ) return;
    this.$refs.myBind('$form', v => {
      this.Form = v;
      // console.warn(v, 11111, this);
    }, NaN);
    this.$refs.myBind('$dialog', v => {
      this.Dialog = v;
      // console.warn(this.fullscreen === '');
      // console.warn(v, 11111, this);
    }, NaN);

    this.clickElement = false;
    const $vnode = this.$vnode, $host = this.$host = $vnode.context;
    // this.Myformdata  = this.formdata  || $host;
    let viewobj = this.viewobj;
    if (!viewobj) {
      viewobj = this.Myviewobj = $forEach(this.$attrs, (v, k) => {
        return k.startsWith('view.') && (
          v = v.split('#'),
          this.icon = v.length === 1 ? '' : v[1].trim(),
          {
            [k.slice(5)]: v[0],
            $button$: ['', v[2] || '']
          }
        );
      }) || ({ $button$: ['', ''] });
      this.icon !== '' && (viewobj.$button$[1] = viewobj.$button$[1] || '确定');
      // console.error(this.$attrs,this.viewobj);
    };
    // console.error(this.actived);
    this.getformdata(true);
    // this.Apiparams.$rule_addUser.$Formdata = w.$set(w.Cache,'$Formdata',{});

    this.$opened = this.$closed = false;
    (this.hidebutton === '' || this.hidebutton) && (this.ihidebutton = true);
    // console.error(this,this.ihidebutton);

    const ref = $vnode.data.ref;
    if (ref) {
      this.$unwatch = $host.$watch(ref, actived => {
        // console.error(111111,actived,1111111);
        this.actived = actived || '';
      });
    };
    // const arr = ["name", "idcard", "username", "loginname", "utel", "email", "age", "usex", "remark"];
    // this.object = Return(arr,(a,v)=>(a[v]=[]).label=v,{__proto__:null});
    // const Myviewobj = this.Myviewobj;
    // console.warn(2222,this);
    $Forms.set(this, $host);
    /*$genFormrule([
      ` name !姓名`,
      'email?邮箱',
      'age?年龄'
    ]);*/
  },

  destroyed() {
    // alert(444);
    // console.error(1111,this);
    this.$unwatch && this.$unwatch();
    $Forms.delete(this);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.MyForm>.el-dialog__wrapper>[fullscreen] {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
</style>


<!-- 测试案列模板
  <myform 
    ref='actived' 
    :hidebutton=false
    x:formdata='$this'
    xx:ruleobj="Apiparams['$rule_'+actived]||Apiparams.$rule"
    x:ruleobj="
      $genFormrule([
        'name  !姓名',
        'email ?邮箱',
        'age   ?年龄'
      ])
    "
    :viewobj="{
      addUser:  [ '新增用户信息', 'el-icon-circle-plus' ], 
      editUser: [ '修改用户信息', 'el-icon-edit-outline'],
      $button$: [ '取消', '确定' ],
      $succeed$: selectContact
    }"
    @close='$form("editUser","reset")'
    confirm='submit=>submit().then'
    >
    
    <template v-slot:usex='{Myformdata}'>
      <el-radio-group 
        v-set:usex='3'
        v-model='Myformdata.usex'>
        <el-radio :label='1'>男</el-radio>
        <el-radio :label='2'>女</el-radio>
        <el-radio :label='3'>保密</el-radio>
      </el-radio-group>
    </template>
    
    <template v-slot:select='{Myformdata}'>
    <el-select
      v-model='Myformdata.select'
      placeholder='请选择'
      clearable >
      <el-option
        :value="item.id"
        :label="item.label"
        v-for="(item,index) in array2" :key="index"
        />
    </el-select>
    </template>
    
    <template v-slot:date='{Myformdata}'>
      <el-date-picker
        slot='date'
        v-model="Myformdata.date"
        start-placeholder="开始日期"
        range-separator="至"
        end-placeholder="结束日期"
        
        remark="👆上面是自定义的,👇下面是固定的无需修改"
      
        style='width:100%'
        :picker-options="$$pickerOptions"
        value-format='yyyy-MM-dd HH:mm:ss'
        type="datetimerange"
        unlink-panels
        align="center" />
    </template>
    
    <el-input 
      :placeholder='( form.length > 0 ? "请输入" : "可在此输入" ) + form.label + ( form.length > 0 ? "" : ".." )'
      v-model="_self[prop]" />
    

    *以下是测试*************
    <h1 slot='email'>
      {{
       44444444 + " " + _error( email )
     }}
    </h1>
    
    <h1 slot='name'>
      {{
       888888 + " " + _error( name )
     }}
    </h1> -->

<!-- <template v-slot:usex='data'>
      <span >  {{ data.prop + 5555555 }} </span>
    </template>

    <template v-slot:email='data'>
      <span >  {{ data.prop + 7777777 }} </span>
    </template> 

  </myform> 
-->



// WEBPACK FOOTER //
// src/components/$MyForm.vue